import React from "react";

const CheckIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1.5C9.82441 1.5 7.69767 2.14514 5.88873 3.35383C4.07979 4.56253 2.66989 6.28049 1.83733 8.29048C1.00477 10.3005 0.786929 12.5122 1.21137 14.646C1.6358 16.7798 2.68345 18.7398 4.22183 20.2782C5.76021 21.8165 7.72022 22.8642 9.85401 23.2886C11.9878 23.7131 14.1995 23.4952 16.2095 22.6627C18.2195 21.8301 19.9375 20.4202 21.1462 18.6113C22.3549 16.8023 23 14.6756 23 12.5C23 9.58262 21.8411 6.78472 19.7782 4.72182C17.7153 2.65892 14.9174 1.5 12 1.5ZM10.4286 16.8921L6.5 12.9636L7.74929 11.7143L10.4286 14.3936L16.2507 8.57143L17.5047 9.81757L10.4286 16.8921Z"
      fill="#02C9A6"
    />
  </svg>
);

export default CheckIcon;
